// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearSave = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '16',
      height: '17',
      viewBox: '0 0 16 17',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#clip0_1566_77547)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M10.5959 3.12512H5.40926C4.26926 3.12512 3.33594 4.05845 3.33594 5.19845V12.7718C3.33594 13.7385 4.02927 14.1518 4.87594 13.6784L7.49593 12.2184C7.77593 12.0651 8.22927 12.0651 8.5026 12.2184L11.1226 13.6784C11.9693 14.1518 12.6626 13.7385 12.6626 12.7718V5.19845C12.6693 4.05845 11.7359 3.12512 10.5959 3.12512Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'clip0_1566_77547',
        },
        /*#__PURE__*/ React.createElement('rect', {
          width: '16',
          height: '16',
          fill: 'white',
          transform: 'translate(0 0.5)',
        }),
      ),
    ),
  );

export { IconLinearSave };
